module.exports = __webpack_public_path__ + "img/EMT-INCA_10X_IC.00854f94.png";